import React, { useEffect, useState } from 'react';
import { Button, Checkbox, ColorPicker, DatePicker, Form, Select, Switch, Tooltip } from 'antd';
import { FloatingLabel } from 'flowbite-react';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import EventEmitter from '../../utils/eventEmitter';
import useDepartmentAPI from '../apis/departmentAPI';




const DepartmentChanges = () => {
  const [form] = Form.useForm();
  const { success, error } = useOutletContext();
  const {department, departments, managers} = useLoaderData();

  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(department.name ? department.name : '');
  const { create, update } = useDepartmentAPI();
  

  const onChangeName = e => setName(e.target.value);

  const handleSubmit = async() => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['color'] = typeof(data.color) === 'string' ? data.color : data.color.toHexString();
    data['seo'] = name.replace(/ /g, '-').toLowerCase();
    create(data, success);
    // console.log(data.color.toHexString())
    console.log(data)
  }

  const handleUpdate = async() => {
    let data = form.getFieldsValue();
    data['name'] = name;
    // data['color'] = typeof(data.color) === 'string' ? data.color : data.color.toHexString();
    data['seo'] = name.replace(/ /g, '-').toLowerCase();
    update(department.seo, data, success);
    // console.log(data)
  }

  useEffect(() => {
    EventEmitter.subscribe('department_response', data => {
      navigate('/employee-app/departments/'+data);
    });
    return () => EventEmitter.unsubscribe('department_response');
  },[]);

  return (
    <div className='container mx-auto' style={{maxWidth: '900px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/employee-app/departments'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Departments</Link> / {params.action}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={ department.name ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {department.name && <Button onClick={handleUpdate}>UPDATE</Button>}
      </div>
      <div className='mt-5 bg-white p-3'>
        <FloatingLabel 
          className='text-2xl' 
          variant="standard" 
          label="Name" 
          value={name} 
          onChange={onChangeName}
          style={{maxWidth: '500px'}}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{span: 5}}
          initialValues={department.seo ? department :
            {active: true, color: "#1677ff"}}
          variant='borderless'
        >
          <Form.Item label='Parent Department' name={'parent_id'} className='font-semibold text-gray-800 mb-1' required>
            <Select options={departments.map(department => ({value: department.id, label: department.name}))} className='font-normal' style={{width: '300px'}}/>
          </Form.Item>
          <Form.Item label='Manager' name={'manager_id'} className='font-semibold text-gray-800 mb-1' required>
            <Select options={managers.map(employee => ({value: employee.id, label: employee.name}))} className='font-normal' style={{width: '300px'}}/>
          </Form.Item>
          <Form.Item label='Color' name={'color'} className='font-semibold text-gray-800 mb-1' required>
            <ColorPicker size="small" showText />
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}
export default DepartmentChanges;